import { getAccessToken } from "@mindlercare/auth";
import {
  createClient,
  createReactClientV11,
} from "@mindlercare/mindlerapi-client";
import { getCountryCode } from "../helpers/getCountryCode";
import { auth } from "../services/auth";

const overrideUrl: string = import.meta.env.VITE_APIV2_URL;

const config = {
  getJwtToken: () => getAccessToken(auth),
  region: getCountryCode() === "SE" ? "SE" : "XG",
  stage: import.meta.env.VITE_STAGE,
  url: overrideUrl,
};

const {
  MindlerApiProvider: MindlerApiProviderV11,
  useMindlerApi,
  useMindlerApiVanillaClient,
} = createReactClientV11(config);

export { MindlerApiProviderV11, useMindlerApi, useMindlerApiVanillaClient };

export const mindlerApiVanilla = createClient(config);
